// Copyright (c) 2016 Deere & Company

import SearchByDropDown, {getDefaultState} from '../state/search-by-dropdown';
import actions from '../../actions-list';

const findMatchingOption = (key, options) => options.find(option => option.key === key);

const updateSearchBy = (state, action) =>
    SearchByDropDown.update(state, {
        selectedOption: {
            $set: findMatchingOption(action.key, state.searchBy)
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_SEARCH_BY]: updateSearchBy
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/shared/reducers/search-dropdown.js